import React from 'react';
import './styles.css';
import {
  FiArrowLeft,
} from 'react-icons/fi';

export default function Header({ history, goBack }) {
  return (
    <section className="status-container">
      {goBack
        && (
          <div className="options">
            <FiArrowLeft className="touchable-icon" size={23} color="#000" onClick={goBack} />
          </div>
        )}
      <div className="divisory">
        <div className="divisory-line" />
      </div>
    </section>

  );
}
